import { render, staticRenderFns } from "./InstagramAnalyticsPublicCampaign.vue?vue&type=template&id=33db3ae4&scoped=true"
import script from "./InstagramAnalyticsPublicCampaign.vue?vue&type=script&lang=ts"
export * from "./InstagramAnalyticsPublicCampaign.vue?vue&type=script&lang=ts"
import style0 from "./InstagramAnalyticsPublicCampaign.vue?vue&type=style&index=0&id=33db3ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db3ae4",
  null
  
)

export default component.exports